import { Pipe, PipeTransform } from "@angular/core";
import { CampaignType, ShowCampaignTypeValue } from "@enums/ECampaigns";

@Pipe({
  name: "campaignType",
})
export class CampaignTypePipe implements PipeTransform {
  transform(value: CampaignType): ShowCampaignTypeValue {
    return ShowCampaignTypeValue[value];
  }
}
